import {Link, useNavigate, useNavigation} from "react-router-dom";
import {IoIosLock} from "react-icons/io";
import {useSession} from "../../../../../redux/Reducers/AuthReducer";

export default function AnswerTemplateRow({className, title, link, download, required_permission, ...props}) {


    return (
        <div className={`flex flex-row justify-center items-center gap-2 border-t-[1px] pt-3 px-2 ${className}`}>
            <div className={"flex-1 text-gray-500"}>
                <p>
                    {title}
                </p>


            </div>
            {
                link ? (
                    <div className={"flex flex-col"}>
                        <div onClick={() => {
                            if (link) {
                                let a = document.createElement("a");
                                a.href = link;
                                a.download = title;
                                a.target = "_blank";
                                a.click();
                            }

                        }} className={"border-[1px] cursor-pointer rounded-md px-3 py-1"}>
                            <p className={"text-sm text-blue-500"}>
                                {
                                    props?.buttonText || "Download"
                                }
                            </p>
                        </div>
                    </div>
                ) : <IoIosLock
                        title={"Available for elite pass users"}
                    className={"text-2xl"}/>

            }
        </div>

    )
}